import { render, staticRenderFns } from "./painelEncomendas.vue?vue&type=template&id=3dda0de2&scoped=true"
import script from "./painelEncomendas.vue?vue&type=script&lang=js"
export * from "./painelEncomendas.vue?vue&type=script&lang=js"
import style0 from "./painelEncomendas.vue?vue&type=style&index=0&id=3dda0de2&prod&scoped=true&lang=scss"
import style1 from "./painelEncomendas.vue?vue&type=style&index=1&id=3dda0de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda0de2",
  null
  
)

export default component.exports